import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuItem from './menu_item';
import { notificationType } from './shared_proptypes';
import { hideNotification, markNotificationRead } from '../actions/creators';

function EmptyMessage() {
  return (
    <div className="notification-dropdown__item">
      <div className="notification-dropdown__list--empty" data-attribute="empty-message">You have no new notifications.</div>
    </div>
  );
}

class MenuList extends Component {
  constructor(...args) {
    super(...args);

    this.handleHideItem = this.handleHideItem.bind(this);
    this.handleClickItem = this.handleClickItem.bind(this);
  }

  handleHideItem(notification, event) {
    event.stopPropagation();
    event.preventDefault();
    this.props.dispatch(hideNotification(notification));
  }

  handleClickItem(notification) {
    this.props.dispatch(markNotificationRead(notification));
  }

  renderNotifications() {
    return (
      this.props.notificationList.map((notification, i) => {
        return <MenuItem notification={notification} key={notification.id} onHideItem={this.handleHideItem} onClick={this.handleClickItem} />;
      })
    );
  }

  render() {
    return (
      <div className="notification-dropdown__list" data-mount="menu-list">
        {this.props.notificationList.length > 0 ? this.renderNotifications() : <EmptyMessage />}
      </div>
    );
  }
}

MenuList.propTypes = {
  dispatch:         PropTypes.func.isRequired,
  notificationList: PropTypes.arrayOf(notificationType()).isRequired
};

export default MenuList;
